import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getAllBannerTemplateFailure, getAllBannerTemplateSuccess } from '../../actions/CreateCampaignActions/getAllBannerTemplateActions';

function* getAllBannerTemplate({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getAllBannerTemplate,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_ALL_BANNER_TEMPLATE_SUCCESS status :", response.data.status);
        console.log("GET_ALL_BANNER_TEMPLATE_SUCCESS data :", response.data.response);
        console.log("GET_ALL_BANNER_TEMPLATE_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getAllBannerTemplateSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_ALL_BANNER_TEMPLATE_FAILURE status :", error?.response?.status);
        console.log("GET_ALL_BANNER_TEMPLATE_FAILURE data:", error?.response?.data);
        console.log("GET_ALL_BANNER_TEMPLATE_FAILURE error :", error);
        console.log('====================================');
        yield put(getAllBannerTemplateFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getAllBannerTemplateSaga() {
    yield takeLatest(actionTypes.GET_ALL_BANNER_TEMPLATE_REQUEST, getAllBannerTemplate);
}

export default getAllBannerTemplateSaga;